import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { EnrollComponent } from './enroll/enroll.component';
import { ApplicationComponent } from './application/application.component';
// import { AuthGuard } from './guards/auth.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ViewComponent } from './view/view.component';
import { ResetQuestionsComponent } from './reset-questions/reset-questions.component';
import { ProfileComponent } from './profile/profile.component';
import { AccountComponent } from './account/account.component';
import { AuthGuard } from './guards/auth.guard';
import { MainpageComponent } from './mainpage/mainpage.component';
import { BusinessEnrollComponent } from './business-enroll/business-enroll.component';
import { UnsubsribedComponent } from './unsubsribed/unsubsribed.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'enroll',
    component: EnrollComponent
  },
  // {
  //   path:'enrollbusiness',
  //   component:BusinessEnrollComponent
  // },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {

        path: '',
        component: MainpageComponent
      },
      {
        path: 'account',
        component: AccountComponent
      },
      {
        path: 'application',
        component: ApplicationComponent
      },
      {
        path: 'view',
        component: ViewComponent
      },

      {
        path: 'changePassword',
        component: ProfileComponent,

      },
      {
        path:'Unsubcribe',
        component:UnsubsribedComponent,
      }
    ]
  },
  {
    path: 'profile',
    component: ResetQuestionsComponent
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
